<div class="image-display"><img #imageDisplay/></div>
<div *ngIf="hasImage">
    <input #originalRadioBtn type="radio" name="img-disply-position" value="{{original}}" checked (click)="onRadioItemClick(originalRadioBtn, imageDisplay)"> Original
    <input #fullWidthRadioBtn type="radio" name="img-disply-position"  value="{{fullWidth}}" (click)="onRadioItemClick(fullWidthRadioBtn, imageDisplay)"> Full Width
</div>
<div><input #imageInput type="file" (change)="onImageChange(imageInput, imageDisplay)"/></div>
<button (click)="onConfirmClick(imageInput, imageDisplay)">Confirm</button>